var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('a',{staticClass:"logo-anchor",attrs:{"href":_vm.link,"aria-label":"Lumiform"}},[_c('Logo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }